// extracted by mini-css-extract-plugin
module.exports = {"termsWrapper":"style_termsWrapper__8A1IJ","Arcade_termsWrapper":"style_Arcade_termsWrapper__XmaC7"};